import _styled from '@emotion/styled/base';
import '@emotion/react';
import React__default from 'react';
import { Spacer, cssShorthandPropsFilter } from '../primitives/Spacer/index.js';
import ButtonBase from './ButtonBase.js';
import PrimaryButton from './PrimaryButton.js';
import SecondaryButton from './SecondaryButton.js';
import TertiaryButton from './TertiaryButton.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { Spacing } from '../primitives/spacing.js';
import { mediaQuery } from '../primitives/media-queries.js';
import { border } from '@hubble/tokens/web';

function getSegmentBgStyles(props) {
  if ((props === null || props === void 0 ? void 0 : props.variant) === 'background') return `background-color: ${props.theme.colorScheme.background.secondary};`;
  return `background-color: ${props.theme.colorScheme.background.primary};`;
}
const fullWidthSegmentStyles = {
  name: "1s8vrjr",
  styles: "justify-content:stretch;width:100%;>a,>button{flex:1 1 auto;}"
} ;
const SpacerContainer = _styled(Spacer, {
  target: "e5j7t901"
})({
  name: "qhxz92",
  styles: "max-width:100%"
} );
const SegmentButtonGroupContainer = _styled("div", {
  target: "e5j7t900"
})("box-sizing:border-box;max-width:100%;overflow-x:auto;padding:", ({
  variant
}) => variant === 'background' ? Spacing.scale[0.5] : '0', ";display:inline-flex;flex-direction:row;align-items:center;gap:", Spacing.scale[1], ";border-radius:", border.radius.full, ";", props => getSegmentBgStyles(props), " ", ({
  stretch
}) => {
  if (stretch) return fullWidthSegmentStyles;
  return `
    justify-content: flex-start;
    > a,
    > button {
      flex: 0 0 auto;
      width: auto;
    }
    `;
}, "@media ", mediaQuery.mobileXsDown, "{", fullWidthSegmentStyles, ";}");
const SegmentVariantButtonMap = {
  primary: PrimaryButton,
  secondary: SecondaryButton,
  background: SecondaryButton
};
const SegmentContainer = ({
  ['data-testid']: dataTestId,
  children,
  className,
  stretch,
  onChange = () => {},
  size = 'md',
  value: valueProp,
  variant = 'background',
  mt = 3,
  ...rest
}) => {
  const ActiveButtonComponent = SegmentVariantButtonMap[variant] || PrimaryButton;
  return jsx(SpacerContainer, {
    className: className,
    "data-testid": dataTestId,
    ...cssShorthandPropsFilter({
      ...rest,
      mt
    }),
    children: jsx(SegmentButtonGroupContainer, {
      stretch: stretch,
      variant: variant,
      children: React__default.Children.map(children, child => {
        const childProps = child === null || child === void 0 ? void 0 : child.props;
        if (React__default.isValidElement(child)) {
          const isSelected = (childProps === null || childProps === void 0 ? void 0 : childProps.value) && (childProps === null || childProps === void 0 ? void 0 : childProps.value) === valueProp;
          const ButtonComponent = isSelected ? ActiveButtonComponent : TertiaryButton;
          return React__default.cloneElement(jsx(ButtonComponent, {
            ...childProps
          }), {
            size,
            onClick: e => {
              var _childProps$onClick;
              onChange === null || onChange === void 0 ? void 0 : onChange(childProps === null || childProps === void 0 ? void 0 : childProps.value);
              childProps === null || childProps === void 0 ? void 0 : (_childProps$onClick = childProps.onClick) === null || _childProps$onClick === void 0 ? void 0 : _childProps$onClick.call(childProps, e);
            }
          });
        }
      })
    })
  });
};
const SegmentButton = ({
  value,
  ...buttonProps
}) => {
  return jsx(ButtonBase, {
    ...buttonProps
  });
};
const Segment = Object.assign(SegmentContainer, {
  Button: SegmentButton
});

export { Segment };
